import BrunchiWordmark from "@/components/BrunchiWordmark";
import { useT } from "@/context/I18nContext";

export default function Footer() {
  const { t } = useT();
  return (
    <footer className="mt-24 border-t border-[color:var(--brunchi-stone)] bg-[color:var(--brunchi-cream)]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <BrunchiWordmark size={84} showTagline={true} />
          <p className="mt-3 text-sm text-[color:var(--brunchi-ink-soft)] leading-relaxed">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--brunchi-green-hover)] mb-3">{t("footer.shop")}</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/shop?category=protein-bars">{t("footer.protein_bars")}</a></li>
            <li><a href="/shop?category=granola">{t("footer.granola")}</a></li>
            <li><a href="/shop?category=sweets">{t("footer.sweets")}</a></li>
            <li><a href="/bundle">{t("footer.build_a_box")}</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--brunchi-green-hover)] mb-3">{t("footer.delivery")}</div>
          <ul className="space-y-2 text-sm text-[color:var(--brunchi-ink-soft)]">
            <li>{t("footer.delivery_cy")}</li>
            <li>{t("footer.delivery_gr")}</li>
            <li>{t("footer.delivery_intl")}</li>
            <li>{t("footer.free_over")}</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--brunchi-green-hover)] mb-3">{t("footer.contact")}</div>
          <ul className="space-y-2 text-sm text-[color:var(--brunchi-ink-soft)]">
            <li><a href="/contact" data-testid="footer-contact-link">{t("nav.contact")}</a></li>
            <li><a href="/corporate-catering" data-testid="footer-catering-link">{t("nav.catering")}</a></li>
            <li><a href="mailto:greg@brunchi.co" data-testid="footer-email">greg@brunchi.co</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--brunchi-stone)] py-4 text-center text-xs font-mono text-[color:var(--brunchi-ink-soft)]">
        © {new Date().getFullYear()} Brunchi · {t("footer.rights")} · EUR (€)
      </div>
    </footer>
  );
}
